exports.dedupeByKey = ({ array, key }) => {

    const seen = {};

    for (const item of array) {
        seen[item[key]] = item; // always overwrite
    }

    return Object.values(seen);
};

exports.filterEmpties = (arr) => arr?.filter((x) => !!x);

exports.alphaSort = (key) => {

    return (a, b) => {

        const aVal = key ? a?.[key] : a;
        const bVal = key ? b?.[key] : b;

        // Both must be strings to compare alphabetically
        if (typeof aVal === 'string' && typeof bVal === 'string') {
            return aVal.localeCompare(bVal, undefined, { sensitivity: 'base' });
        }

        // Handle falsy values
        if (!aVal && !bVal) {
            return 0;
        }
        else if (!aVal) {
            return 1;
        }
        else if (!bVal) {
            return -1;
        }

        // Fallback compare
        if (aVal === bVal) {
            return 0;
        }
        else if (aVal > bVal) {
            return 1;
        }

        return -1;
    };
};
